import { Plus } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { useGetLicences } from "@/features/applications/repositories/licences-repository";
import { useState } from "react";


import Table from "@/components/Table";
import Button from "@/components/buttons/Button";
import ApplicationsFilters from "../applications-filters";
import LicencesApplicationsItem from "./licences-applications-item";
import Pagination from "@/components/Pagination";
import { LICENCE_STATUS_OPTIONS } from "@/utils/application-status";



export default function LicencesApplications() {
    const [searchParams, _] = useSearchParams();
    const [page, setPage] = useState<number>(0);


    // page is 0-based locally (matches the paginator); the API is 1-based, so send page + 1.
    const { licences, isLoading } = useGetLicences({
            pager: { page: page + 1, size: 10 },
            filter: Object.fromEntries(searchParams.entries())

    });

    const columns = ["Application ID", "Project Name", "Project Location", "Status", "Action"];
    
    return (
        <div className="mt-5 px-4">
                <div className="flex justify-between items-center">
                        <ApplicationsFilters statusOptions={LICENCE_STATUS_OPTIONS} showDateRange />
                        <Link to={"/applications/apply"}>
                            <Button
                                intent="primary"
                                size="md"
                                leftIcon={<Plus size={20} />}
                            >
                                New Applications
                            </Button>
                        </Link>
                </div>
        <Table.Container>
            <Table>
                <Table.Header>
                    <Table.Row>
                        {
                            columns.map((header) => (
                                <Table.Head key={header}>
                                    {header}
                                </Table.Head>
                            ))
                        }
                    </Table.Row>
                </Table.Header>
        
                <Table.Body>
                    {
                        isLoading && (
                        <Table.Loading columns={columns.length} />
                    )}
        
                    {
                        !isLoading && licences && licences.results.length === 0 && (
                            <Table.Empty />
                        )
                    }

                    {
                        !isLoading && licences && (
                            licences.results.map((item:any, index: number) => (
                            <LicencesApplicationsItem content={item} key={index} />
                        ))
                    )}
                </Table.Body>
                <Table.Footer>
                    <Table.Row>
                        <Table.Cell colSpan={columns.length}>
                            <div className="flex justify-between items-center font-light">
                                <div>
                                    Showing {licences?.results.length} of {licences?.pagination?.total}
                                </div>
                                <Pagination
                                        currPage={page}
                                        pageCount={licences?.pagination?.last_page ?? 0}
                                        setCurrPage={(value) => setPage(value)}
                                    />
                            </div>
                        </Table.Cell>
                    </Table.Row>
                </Table.Footer>
            </Table>
        </Table.Container>
        </div>
    )
}

